export class InternalError extends Error {
    readonly name: string = "InternalError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
